
 

const MoreSolutionsShield = ()=>{
    return(
        <>
        <section className='moreSolutionMain'>
            <div className='container'>
                    <div className="row">
                        <div className="col-lg-8 col-md-12 col-sm-12">
                            <div className="moreSolutionHeading">
                                <h2>Discover more solutions</h2>
                                <p>Rental tools to help you scale your business</p>
                            </div>
                        </div>
                    </div>

                    <div className='moreSolutionOuter'>
                        <div className="moreSolutionInner moreSolutionGreen">
                            <a href="/rentdirect">
                            <div className="green_overlay"></div>
                                <figure><img src="/img/rent_direct_logo.svg" alt="logo"/></figure>
                            </a>
                        </div>
                        
                        <div className="moreSolutionInner moreSolutionSky">
                            <a href="/rent-id">
                                <div className="sky_overlay"></div>
                                <figure> <img src="/img/rent_id_logo.svg" alt="logo"/></figure>
                            </a>
                        </div>

                        <div className="moreSolutionInner moreSolutionWhite">
                            <a href="/rentai">
                                <div className="white_overlay"></div>
                                <figure><img src="/img/rent_ai_logo.svg" alt="logo"/></figure>
                            </a>
                        </div>

                        <div className="moreSolutionInner moreSolutionPurple">
                            <a href="/rentsuccess">
                                <div className="purple_overlay"></div>
                                <figure><img src="/img/rent_success_logo.svg" alt="logo"/></figure>
                            </a>
                        </div>


                        <div className="moreSolutionInner moreSolutionYellow">
                            <a href="/rentacademy">
                                <div className="yellow_overlay"></div>
                                <figure> <img src="/img/rent_academy_logo.svg" alt="logo"/></figure>
                            </a>
                        </div>
                    </div>
            </div>
        </section>
        </>
    )
}

export default MoreSolutionsShield;